export const phoneRegex = new RegExp(
  /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/
);

export const emailRegex = new RegExp(
  /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g
);
